import { instance } from './config';

export const getNotificationsByTransactionId = (transactionId) => {
   return instance.get(`/notification/transaction/${transactionId}`);
};

export const sendSms = (requestData) => {
   return instance.post(`/notification/sms/send`, requestData);
};
